export default __webpack_public_path__ + "static/Крысиные бега_21-8e520c41e751d86cfe679b1d25708dd1.jpg";